import { ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { notify } from 'notiwind';

export function useFavorite(transferPrograms) {
    const toggleFavoriteInProgress = ref(new Set());

    const toggleFavorite = (program) => {
        if (!program || !program.id || !program.slug) return;
        if (toggleFavoriteInProgress.value.has(program.id)) return;

        toggleFavoriteInProgress.value.add(program.id);
        const wasAlreadyFavorite = program.is_favorite;

        router.post(
            `/resources/transfer-partners-guide/${program.slug}/toggle-favorite`,
            {},
            {
                preserveState: true,
                preserveScroll: true,
                onStart: () => {
                    const data = transferPrograms.value.data;
                    const idx = data.findIndex((p) => p.id === program.id);
                    if (idx !== -1) {
                        data[idx].is_favorite = !program.is_favorite;
                    }
                },
                onSuccess: () => {
                    toggleFavoriteInProgress.value.delete(program.id);
                    notify(
                        {
                            group: 'success',
                            title: wasAlreadyFavorite ? 'Removed from favorites' : 'Added to favorites',
                            text: wasAlreadyFavorite
                                ? 'Program has been removed from favorites.'
                                : 'Program has been added to favorites.',
                        },
                        4000
                    );
                },
                onError: () => {
                    toggleFavoriteInProgress.value.delete(program.id);
                    const data = transferPrograms.value.data;
                    const idx = data.findIndex((p) => p.id === program.id);
                    if (idx !== -1) {
                        data[idx].is_favorite = !data[idx].is_favorite;
                    }
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'Failed to update favorites. Please try again.',
                        },
                        4000
                    );
                },
            }
        );
    };

    return {
        toggleFavorite,
        toggleFavoriteInProgress,
    };
}
